export const property = {
  gamefi: "趣投帳戶",
  mc_official_verify_unofficial: "非官方認證渠道",
  mc_official_verify_official: "官方",
  mc_official_verify_fotter_tip_1:"關於防範假冒Biking官方工作人員進行網絡/電話詐騙的風險提示",
  mc_official_verify_fotter_tip_2:"關於警惕不法分子冒充、濫用“Biking”名義詐騙的嚴正聲明及風險提示",
  mc_official_verify_modal_tip_1:"您查詢的 【{query}】經確認為Biking官方渠道",
  mc_official_verify_modal_tip_3: "請核實您輸入的信息和格式是否正確：",
  mc_official_verify_modal_tip_4: "手機號碼：xx-xxxxxxxxx",
  mc_official_verify_modal_type_email: "郵箱",
  mc_official_verify_modal_type_domain: "網址",
  mc_official_verify_modal_type_channel: "渠道",
  mc_official_verify_input_placeholder: "請您輸入正確的信息和格式進行驗證",
  mc_official_verify_head_title: "Biking交易所官方驗證通道| Biking交易所",
  mc_official_verify_head_description: "Biking交易所官方驗證通道",
  mc_official_verify_title: "官方驗證通道",
  mc_official_verify_discription_new:"為避免釣魚及網絡詐騙給您帶來資產損失，您可在此頁面驗證網址、郵箱地址、電話號碼，或推特、電報等社交賬號是否為Biking官方認證渠道。",
  mc_official_verify_fotter_tip_3:"Biking用戶必讀：預防詐騙手冊，警惕詐騙手段升級！",
  mc_unofficial_verify_modal_tip_1:"您查詢的 【{query}】不是Biking官方渠道",
  mc_official_verify_discription:"為防止不法分子借用Biking全球站名義進行詐騙，您可通過此頁面確認聯繫您的電話、微信等是否為Biking官方渠道",
  mc_official_head_title1: "核實Biking官方渠道、新聞和出版物",
  mc_official_head_keywords1: "Biking核實，Biking新聞，Biking官方賬戶",
  mc_official_head_description1:"確保Biking渠道的真實性。使用我們的官方驗證工具來確認與 Biking 相關的頻道、新聞和出版物的合法性。",
  mc_official_verify_verified_title: "官方認證渠道",
  mc_official_verify_modal_tip_5: "Telegram/X/Facebook/Youtube：@xxxxx（有@符號）",
  mc_official_verify_modal_tip_6: "TikTok/Instagram：xxxx（無@符號）",
  mc_official_verify_modal_tip_7: "Discord：xxxx#xxxx（無@符號）",
  mc_official_verify_modal_tip_8:"LinkedIn/Telegram群/Medium/Reddit：https://xxxxx（網站鏈接）",
  mc_official_verify_modal_tip_9: "若您對信息格式有疑問，請隨時聯繫在線客服。",
  mc_official_verify_modal_tip_10: "*請不要將您的賬戶信息與密碼透露給任何人。",
  mc_official_verify_modal_tip_11:"*謹防詐騙，謹慎操作。",
  tagtip: "如果存款平台沒有要求填寫評論，此欄可以留空。",
  tagtip1: "Tag 是用於識別特定帳戶或使用者的獨特代碼，能夠確保資金發送給正確的收款人。",
  tagtip2: "其他交易平台或錢包可能會將 Tag 稱為數位ID、Tag、Memo、Note、Remark、備註等。",
  tag: "請輸入評論",
  qbcbcg: "請同時複製TON地址和評論，以確保成功充幣。",
  qsrzqje: "請輸入正確的金額",
  games: "遊戲帳戶",
  cbxz: "Ethereum（ERC20）充幣須知",
  tbxz: "Ethereum（ERC20）提幣須知",
  ctbzysx: "請注意，每次FUFU官方智能合約轉帳都會收取額外的2%費用。",
  dzcw: "地址錯誤",
  czqkqrs: "儲值區塊確認數",
  mc: "名稱",
  cjsj: "創建時間",
  lx: "類型",
  sl: "數量",
  cwjl: "財務記錄",
  ylzh: "盈利",
  ddtx: "等待提現",
  txcg: "提現成功",
  yhcx: "用戶撤銷",
  qbcbjl: "全部充幣記錄",

  zczl: "資產總覽",
  zjzh: "資金賬戶",
  mbzh: "買幣賬戶",
  xhzh: "現貨賬戶",
  hyzh: "合約賬戶",
  lczh: "理財帳戶",
  gdzh: "跟單賬戶",
  giftzh: "贈金賬戶",
  bwzh: "幣王卡",
  mozh: "模拟賬戶",
  mnhy: "模擬合約",
  sxffy: "系統返佣",
  kt: "空投",
  xtkc: "系統扣除",
  zcfb: "資產分佈",
  zcdt: "資產動態",
  zh: "帳戶",
  zc: "資產",
  czjl: "充值記錄",
  txls: "提現歷史",
  hzjl: "劃轉記錄",
  mmjl: "買賣記錄",
  cb: "充幣",
  tx: "提現",
  hz: "劃轉",
  mb: "買幣",
  jy: "交易",
  zwsj: "暫無數據",
  ckqb: "查看全部",

  // table
  bz: "幣種",
  qc: "全稱",
  zhze: "賬戶總額",
  syzc: "剩餘資產",
  djzc: "凍結資產",
  cz: "操作",
  sl: "數量",
  cbdz: "充幣地址",
  sj: "時間",
  zt: "狀態",
  ms: "描述",
  hzfx: "劃轉方向",
  hzse: "劃轉數額",
  txdz: "提現地址",
  sxf: "手續費",
  ddh: "訂單號",
  zj: "總價",
  dj: "單價",
  jysl: "交易數量",
  jydx: "交易對象",
  zhqy: "賬戶權益",
  zhqytips: "賬戶權益=可用保證金+倉位保證金",
  kybzj: "可用保證金",
  kybzjtips: "可用來開倉和劃轉出去的保證金",
  cwbzj: "倉位保證金",
  cwbzjtips: "用於維持現有倉位的保證金",

  // search
  srbz: "請輸入對應幣種",
  ycxzc: "隱藏小資產",
  sy: "所有",
  qb: "全部",
  qb: "全选",
  zhi: "至",
  ksrq: "開始日期",
  jsrq: "結束日期",
  cx: "查詢",
  dc: "導出",
  zjqt: "最近7天",
  zjygy: "最近一個月",
  qbsj: "全部時間",
  usdt: "USDT",
  ddlx: "訂單類型",
  gm: "購買",
  cs: "出售",

  // recharge
  czxq: "充值詳情",
  usdtcbjl: "{coinName}充幣記錄",
  cbsl: "充幣數量",
  cbzt: "充幣狀態",
  crdbz: "請選擇您需要充入的幣種",
  tqdbz: "請選擇您需要提取的幣種",
  rmbz: "熱門幣種",
  qxz: "請選擇",
  cbwl: "充幣網絡",
  cbtips: "請確保您已選擇與提幣平台一致的網絡進行充幣，否則將造成資產損失。 ",
  txfs: "提現方式",
  lstx: "鏈上提現",
  xyb: "下一步",
  yxzdq: "已選擇當前",
  dbz: "的幣種",
  cxxz: "重新選擇",
  dzkbz: "地址庫地址不足，請聯繫管理員",
  qxzcrdbz: "請先選擇充入的幣種",
  qxzcbwl: "請選擇充幣網絡",
  qxztqdbz: "請先選擇提取的幣種",
  cr: "充入",
  tq: "提取",
  cbxq: "充幣詳情",
  txxq: "提現詳情",
  usdttxjl: "{coinName}提現記錄",
  qbtxjl: "全部提現記錄",
  zyxx: "重要信息：您只可發送{coinName}至此地址，若發送其他數字貨幣，您將會失去這筆資金。 ",
  jzjcr: "將資金充入",
  smewm: "掃描二維碼或複制下列信息到發送平台",
  xcdzcz: "向此地址充值非此類型幣種將導致您的資產無法找回",
  xcdzczss: "充入XRP 時請務必複製 tag，否則將會造成資金損失",
  znhycz: "目前不支持智能合約充值、打包充值、區塊獎勵充值",
  usdtcbdz: "{usdtcbdz}充幣地址",
  fzdz: "複製地址",
  usdtdz: "{coinName}地址",
  zxcbe: "最小充幣額",
  zytx2:
    "重要信息：請確保接受平台支持您所選擇的 {coinName} 網絡，否則您將丟失此資金。 ",
  kytxwl: "{coinName} 可用的提現網絡",
  xzwl: "選擇網絡",
  dzym: "{coinName} 地址",
  srdz: "輸入地址或從地址薄內選擇",
  jymm: "交易密碼",
  qsrjymm: "請輸入交易密碼",
  zxtbe: "最小提幣額：{minAmount}",
  ky: "可用：",
  zhztbxe: "賬戶總提幣限額",
  gjxyddj:
    "根據您的驗證等級，您在 24 小時內只能提幣有限額度。該限額會將USD轉換為您選擇的數字貨幣計算。 ",
  scbdjd:
    "由於幣價波動較大，該幣種的手續費為浮動手續費，根據前 24 小時平均幣價，收取折合 0.2-0.2 USDT 的手續費增加手續費提升到賬速度",
  yqdz: "預期到賬",
  yqdzwf: "預期到賬不能為負數",
  sfrz: "身份認證",
  ggyzm: "Google身份驗證碼",
  dxyzm: "短信驗證碼",
  yxyzm: "郵箱驗證碼",
  qsryzm: "請輸入驗證碼",
  fsyzm: "發送驗證碼",
  cxfs: "重新發送",
  tj: "提交",
  qxztxwl: "請選擇提現網絡",
  qsrdz: "請輸入地址",
  qxzdz: "請選擇地址",
  qxzyzfs: "請選擇一種身份認證方式",
  qsrtqsl: "請輸入提取的數量",
  qwcyz: "請完成驗證",
  qqrbdsj: "請先確認是否綁定手機",
  qqrbdyx: "請先確認是否綁定郵箱",
  fzcg: "複製成功！ ",
  tbcg: "提幣成功",
  usdttxdz: "{coinName}提現地址",
  lmc: "鏈名稱:",
  qtj: "*請添加",
  dz: "地址",
  fei: "非",
  zjds: "地址可能會導致資產丟失",
  yzfs: "驗證方式",
  yzm: "驗證碼",
  remark: "備註",
  qsrremark: "請輸入備註",
  tjdzcg: "添加地址成功",
  qxxzyzfs: "請先選擇驗證方式",
  qsrtxdz: "請輸入提現地址",
  stop: "暫停",

  //status
  qr0: "0確認",
  qr1: "1確認",
  dqr: "待確認",
  czcg: "充值成功",
  hzz: "劃轉中",
  ywc: "已完成",
  sb: "失敗",
  zzcl: "正在處理",
  ddsh: "等待審核",
  txcg: "提現成功",
  cxcg: "撤銷成功",
  ddtx: "等待提現",
  txsb: "提現失敗",
  slsb: "上鍊失敗",
  dfk: "待付款",
  yfk: "已付款",
  yqx: "已取消",
  ssz: "申訴中",
  gdfrhz: "跟單分潤劃轉",
  hyzh_to_gdzh: "合約賬戶 - 跟單賬戶",
  gdzh_to_hyzh: "跟單賬戶 - 合約賬戶",
  ddcl: "等待處理",
  cg: "成功",

  // dialog
  zchz: "資產劃轉",
  ljhz: "立即劃轉",
  cong: "從",
  dao: "到",
  qtzh: "其他賬戶",
  qxzbz: "請選擇幣種",
  qsrsl: "請輸入數量",
  khz: "可劃轉:",
  ye: "餘額:",
  hzcg: "劃轉成功",

  // h5
  zcgl: '資產概覽',
  xrzx: '新人專享',
  zzc: '總資產',
  jryk: '今日盈虧',
  zgjz: '最高價值3200 USDT新人禮包等您來拿',
  zhrj: '為您的賬戶入金',
  xzrjfs: '入金後即可購買數字貨幣，您可依照實際情況選擇入金方式',
  czszhb: '充值數字貨幣',
  yyydszhb: '將您在其他平台已擁有的數字貨幣充值到Biking賬戶中。 ',
  czfb: '充值法幣',
  czzhz: '將您已擁有的法定貨幣充值到Biking賬戶中，支持銀行卡，轉賬等多種支付方式',
  maibi: '買幣',
  tgdsfmb: '通過銀行卡、P2P、第三方等方式購買數字貨幣',
  yqyl: '邀請有禮',
  yqfy: '邀請好友享20%返佣',
  cxzzn: '初學者指南',
  czzh: '創建一個Biking賬戶',
  hdxrj: '獲得100USDT 新人獎金',
  ck: '存款',
  tzndzh: '投資您的賬戶，開始您的旅程，支持多種付款方式',
  wcsfrz: '完成身份認證（KYC）',
  hgzh: '完成身份認證（KYC）並成為合規賬戶',
  ksjy: '開始交易',
  tsgd: '出售、購買或複制交易，探索更多',
  ksndlc: '開始您的旅程',
  kjydjmhb: '可交易的加密貨幣',
  jmhb: '加密貨幣總價值是12284.85億美金',
 zengjin: "贈金",
  lc: "理財",
  mb: "買幣",
  lsjl: "歷史記錄",
  zclb: "資產列表",
  shaixuan: "篩選",
  批量导入地址:'批次匯入地址',
  请输入地址或名称:'請輸入地址或名稱',
  地址名称:'地址名稱',
  上传普通地址:'上傳普通地址',
  上传成功:'上傳成功',
  一次只能上传一个文件哦:'一次只能上傳一個文件哦',
  文件大小不得超过10M:'文件大小不得超過10M',
  请先选择要上传的文件:'請先選擇要上傳的文件',
  只能上传后缀是:'只能上傳後綴是.xlsx或.xls的檔案或.csv的文件',
  将文件拖到此处:'將文件拖到此處，或',
  点击上传:'點擊上傳',
  最大1MB:'CSV、XLS、XLSX檔 最大1MB',
  编号:'編號',
  所属网络:'所屬網絡',
  地址簿:'地址簿',
  新增地址:'新增地址',
  提币地址一次不超过100个:'提幣地址一次不超過100個',
  添加地址:'新增地址',
  保存地址:'儲存地址',
  下载模板:'下載模板',
  批量提现:'批量提現',
  请输入Memo:'請輸入Memo',
  请输入地址名称:'請輸入地址名稱',
  您可以通过:'您可以透過CSV、XLS或XLSX格式檔案（最大1MB）上傳最多20個普通位址，每列標題必須與模版一致，否則將會導致上傳失敗。'
}


// WEBPACK FOOTER //
// ./src/i18n/lang/property/tw.js